/* eslint-disable react/prop-types */
import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { connect } from 'react-redux'

import { deleteSelected, newRule } from '../../actions'
import { ButtonIcon } from '../styles'
import { ActionOption } from '../styles/list'

const Options = ({ rule, sideview, deleteSelected, newRule }) => (
    <Dropdown id="alarm-card-options" className="alarm-card-options" pullRight={true}>
        <ButtonIcon fontWeight={400} className={`far fa-ellipsis-v`} bsRole="toggle" />
        <Dropdown.Menu>
            <ActionOption color="#37a3ef" onSelect={() => newRule({ ...rule, global: false, id: undefined })}>
                <i className="far fa-copy" />
                Duplicate
            </ActionOption>
            <ActionOption color="#c43535" onSelect={() => deleteSelected([rule], sideview)}>
                <i className="far fa-trash-alt" />
                Delete
            </ActionOption>
        </Dropdown.Menu>
    </Dropdown>
)

export default connect(() => ({}), { newRule, deleteSelected })(Options)
